import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { DocumentType, } from '@/helpers/entities/interfaces/v2/forms/KycFormFields';
let KYCDocumentFormMixin = class KYCDocumentFormMixin extends Vue {
    constructor() {
        super(...arguments);
        this.kycSelfieWithPrimaryId = {
            documentType: DocumentType.SELFIE_WITH_PRIMARY_ID_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycPrimaryId = {
            documentType: null,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycSelfieWithSecondaryId = {
            documentType: DocumentType.SELFIE_WITH_SECONDARY_ID_2_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycSecondaryId1 = {
            documentType: null,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycSecondaryId2 = {
            documentType: null,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycDtiRegistration = {
            documentType: DocumentType.DTI_REGISTRATION_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycBir = {
            documentType: DocumentType.BIR_2303_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycSecCertReg = {
            documentType: DocumentType.SEC_CERTIFICATE_REGISTRATION_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycArticleOfPartnership = {
            documentType: DocumentType.ARTICLES_OF_PARTNERSHIP_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycNotarizePartnerCert = {
            documentType: DocumentType.NOTARIZED_PARTNER_CERTIFICATE_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycNotarizeSecCert = {
            documentType: DocumentType.NOTARIZED_SECRETARY_CERTIFICATE_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kyclatestGIS = {
            documentType: DocumentType.LATEST_GIS_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycArticleOfIncorporation = {
            documentType: DocumentType.ARTICLES_OF_INCORPORATION_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycProofOfCompanyReg = {
            documentType: DocumentType.PROOF_OF_COMPANY_REGISTRATION_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycCountryIssuedBusinessLicense = {
            documentType: DocumentType.COUNTRY_ISSUED_BUSINESS_LICENSE_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycBankBookScan = {
            documentType: DocumentType.BANK_BOOK_SCAN_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
        this.kycServiceAgreement = {
            documentType: DocumentType.SERVICE_AGREEMENT_DOCUMENT,
            purpose: 'KYC_DOCUMENT',
            fileName: '',
            file: null,
            isUploading: false,
        };
    }
};
KYCDocumentFormMixin = __decorate([
    Component({
        name: 'KYCDocumentFormMixin',
    })
], KYCDocumentFormMixin);
export default KYCDocumentFormMixin;
